// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__view__Tab__root"};


//////////////////
// WEBPACK FOOTER
// ./src/stores/catalog/flexLayout/flexlayout-react/src/view/Tab.css
// module id = 964
// module chunks = 10